import {
  jb_info_box_css_default
} from "./chunk.3UZPNWPN.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.3FKBYJ4V.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  JBCookie
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-info-box/jb-info-box.ts
var JbInfoBox = class extends Initiable(Spaceable(r)) {
  constructor() {
    super(...arguments);
    this.isInText = false;
  }
  firstUpdated() {
    if (this.countryCondition && this.countryCondition.toLowerCase() !== JBCookie.getI18nCookieData().country.toLowerCase()) {
      this.style.setProperty("display", "none");
    }
  }
  _getContentSpacingProperties() {
    return { type: "text" };
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "info-box"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <div
        class="${Rt({
      "in-text": !!this.isInText,
      [`bg-${this.background}`]: this.background,
      isbordered: !this.background
    })}"
      >
        ${this.headline ? ke`<h2>${this.headline}</h2>` : D}
        <jb-richtext @jb-link:clicked=${this._tracking}>${ae(this.content)}</jb-richtext>
        ${this.button ? ke`<jb-button-secondary
              .link=${this.button.link}
              @jb-link:clicked=${this._tracking}
              >${this.buttonText}</jb-button-secondary
            >` : D}
      </div>
    `;
  }
};
JbInfoBox.styles = [reset_css_default, jb_info_box_css_default];
__decorateClass([
  n()
], JbInfoBox.prototype, "background", 2);
__decorateClass([
  n({ type: Object })
], JbInfoBox.prototype, "button", 2);
__decorateClass([
  n()
], JbInfoBox.prototype, "buttonText", 2);
__decorateClass([
  n()
], JbInfoBox.prototype, "content", 2);
__decorateClass([
  n()
], JbInfoBox.prototype, "countryCondition", 2);
__decorateClass([
  n()
], JbInfoBox.prototype, "headline", 2);
__decorateClass([
  n({ type: Boolean })
], JbInfoBox.prototype, "isInText", 2);
JbInfoBox = __decorateClass([
  customElement("jb-info-box")
], JbInfoBox);

export {
  JbInfoBox
};
